module.exports = Dropzone;


//////////////////
// WEBPACK FOOTER
// external "Dropzone"
// module id = 1140
// module chunks = 1